<template>
  <div id="rolePower">
    <headerTop title="权限管理" :getleft="showArrow" :showUser="showUser" />
    <el-row :span="10">
      <div :span="5">
        <navLeft :activeIndex="2" />
      </div>
      <div class="system" :span="20" style="background: #fff">
        <div slot="header" class="clearfix" style="
            width: 100%;
            height: 50px;
            line-height: 50px;
            text-indent: 20px;
            border-bottom: 1px solid #ddd;
          ">
          <span style="font-size: 16px; font-weight: 600">菜单管理</span>
        </div>
        <div style="
            display: flex;
            justify-content: space-between;
            color: #409eff;
            margin-bottom: 20px;
          ">
          <!-- <span>菜单名称</span>
          <span> 新增 编辑 删除 </span> -->
        </div>
        <div style="margin-left: 20px" v-loading="loading" element-loading-text="加载数据中，请稍后.....">
          <el-tree :data="data" node-key="menuId" :props="props" default-expand-all :expand-on-click-node="false">
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span>{{ node.label }}</span>
              <span class="addPosition">
                <el-button v-if="data.allowUdpate != 0 && data" type="text" @click="() => add(data)">
                  <i class="el-icon-plus"></i>
                </el-button>
                <el-button v-if="data.allowUdpate != 0 && data" type="text" @click="() => edit(data)">
                  <i class="el-icon-edit-outline"></i>
                </el-button>
                <el-button v-if="data.allowUdpate != 0 && data" type="text" @click="() => remove(node, data)">
                  <i class="el-icon-delete"></i>
                </el-button>
              </span>
            </span>
          </el-tree>
        </div>
      </div>
    </el-row>
    <div v-if="showadd">
      <el-dialog :title="infoTitle" :visible.sync="showadd" :close-on-click-modal="false" :modal-append-to-body="false"
        width="30%" class="dialog-class">
        <el-form ref="form" :rules="rules" :model="form" label-width="130px">
          <el-form-item label="菜单名称：" prop="menuName">
            <el-input v-model.trim="form.menuName"></el-input>
          </el-form-item>

          <el-form-item label="权限标识：" prop="perms">
            <el-input v-model.trim="form.perms"></el-input>
          </el-form-item>
          <el-form-item label="同级或子级：" v-if="infoTitle == '新增'" prop="addType">
            <el-radio-group v-model="form.addType">
              <el-radio label="0" value="0">同级</el-radio>
              <el-radio label="1" value="1">子级</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="菜单类型：" prop="position">
            <el-radio label="0" v-model="form.position" @change="changeUpdate" value="0">系统</el-radio>
            <el-radio label="2" v-model="form.position" @change="changeUpdate" value="2">子系统权限管理</el-radio>
            <el-radio label="3" v-model="form.position" @change="changeUpdate" value="3">无</el-radio>
          </el-form-item>
          <div v-if="form.position == 0">
            <el-form-item label="系统图标：" v-if="form.position == 0">
              <div class="upload-demo" style="display: flex; margin: 0">
                <div @click="fileClick('uploadFile1')" ref="select_frame" class="el-upload el-upload--text dropbox">
                  <div class="el-upload-dragger" style="width: 150px; height: 100px">
                    <i style="color: #06abf3" class="el-icon-upload"></i>
                    <div class="el-upload__text">点击上传图标</div>
                  </div>
                  <input type="file" id="uploadFile1" multiple
                    accept=".rar, .zip, .doc, .docx, .pdf, .jpg, .ppt, .xls, .xlsx, .txt, .png"
                    @change="fileChange($event)" style="display: none" />
                </div>
                <div v-if="fileNameList.length > 0">
                  <div style="position: relative; float: left; margin-right: 10px" v-for="(item, index) in fileNameList"
                    :key="index">
                    <div>
                      <p class="demonstration buttonp" v-if="infoTitle == '新增'">
                        <el-image style="width: 100px; height: 100px" :src="item.result"
                          :preview-src-list="[item.result]">
                        </el-image>

                        <span style="color: red" type="text" class="myapp-main-btn buttonspan red"
                          @click="fileDel(index)">删除</span>
                      </p>
                      <p v-if="infoTitle == '编辑'" class="demonstration buttonp">
                        <el-image v-if="form.icon" style="width: 100px; height: 100px" :src="form.icon"
                          :preview-src-list="[form.icon]">
                        </el-image>
                        <el-image v-else style="width: 100px; height: 100px" :src="item.result"
                          :preview-src-list="[item.result]">
                        </el-image>
                        <span style="color: red" type="text" class="myapp-main-btn buttonspan red"
                          @click="fileDel(index)">删除</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </el-form-item>
            <el-form-item :key="0" label="管理路径：" v-if="form.position == '0' || form.position == '2'" prop="manageUrl">
              <el-input @input="changeUpdate" v-model="form.manageUrl">
              </el-input>
            </el-form-item>
            <el-form-item :key="1" label="客户端ID：" v-if="form.position == 0" prop="clientId">
              <el-input @input="changeUpdate" v-model="form.clientId"></el-input>
            </el-form-item>
            <el-form-item :key="2" label="客户端密钥：" v-if="form.position == 0" prop="clientSecret">
              <el-input @input="changeUpdate" v-model="form.clientSecret"></el-input>
            </el-form-item>
            <el-form-item :key="3" label="应用主页：" v-if="form.position == 0" prop="indexUrl">
              <el-input @input="changeUpdate" v-model="form.indexUrl"></el-input>
            </el-form-item>
            <el-form-item :key="4" label="应用名称：" v-if="form.position == 0">
              <el-input @input="changeUpdate" v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item :key="5" label="应用描述：" v-if="form.position == 0">
              <el-input @input="changeUpdate" v-model="form.describe"></el-input>
            </el-form-item>
          </div>
          <div v-else-if="form.position == 2">
            <el-form-item :key="6" label="管理路径：" v-if="form.position == '2'" prop="manageUrl">
              <el-input @input="changeUpdate" v-model="form.manageUrl">
              </el-input>
            </el-form-item>
            <el-form-item :key="7" label="子权限API：" v-if="form.position == '2'" prop="manageUrlJson">
              <el-input v-model="form.manageUrlJson"></el-input>
            </el-form-item>
            <el-form-item :key="8" label="应用模块：" v-if="form.position == '2'" prop="clientId2">
              <el-select v-model="form.clientId2">
                <el-option v-for="(item, index) in clientList" :key="index" :label="item.clientName"
                  :value="item.clientId"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelSubmit">取 消</el-button>
          <el-button type="primary" @click="addSubmit('form')" v-if="infoTitle == '新增'">确 定</el-button>
          <el-button type="primary" @click="editSubmit('form')" v-if="infoTitle == '编辑'">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import headerTop from "../components/headTop.vue";
import navLeft from "../components/navLeft.vue";
let id = 1000;
export default {
  data() {
    const data = [];
    var validateClientID = (rule, value, callback) => {
      let checkRule = /^[0-9a-zA-Z]{2,20}$/;
      if (value === "") {
        callback(new Error("请输入客户端ID"));
      } else if (!checkRule.test(value)) {
        callback(new Error("请输入正确的客户端ID"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      clickIdIsTrue: true,
      clientList: [],
      showUser: true,
      fileList: [],
      fileNameList: [],
      props: {
        label: "menuName",
        children: "childs",
        isLeaf: "leaf",
      },
      infoTitle: "新增",
      form: {
        clickId: "",
        indexUrl: "",
        name: "",
        describe: "",
        menuName: "",
        perms: "",
        addType: "0",
        position: "0",
        manageUrlJson: "",
        manageUrl: "",
        isClient: "false",
        clientId: "",
        clientId2: "",
        clientSecret: "",
        icon: "",
      },
      addData: "",
      showadd: false,
      showArrow: true,
      data: JSON.parse(JSON.stringify(data)),
      rules: {
        //
        clientId2: [
          { required: true, message: "应用模块不能为空", trigger: "blur" },
        ],
        menuName: [
          { required: true, message: "菜单名称不能为空", trigger: "blur" },
        ],
        perms: [
          { required: true, message: "权限标识不能为空", trigger: "blur" },
        ],
        addType: [
          { required: true, message: "同级或子级不能为空", trigger: "blur" },
        ],
        position: [
          { required: true, message: "位置不能为空", trigger: "blur" },
        ],
        manageUrlJson: [
          {
            required: true,
            message: "子权限不能为空且以http://www或者https://www开头",
            trigger: "blur",
          },
        ],
        clientId: [
          {
            required: true,
            message: "客户端ID不能为空且只能是数字和字母且长度为2到20",
            trigger: "blur",
            validator: validateClientID,
          },
        ],
        clientSecret: [
          { required: true, message: "客户端秘钥不能为空", trigger: "blur" },
        ],
        indexUrl: [
          {
            required: true,
            message: "应用主页不能为空且以http://www或者https://www开头",
            trigger: "blur",
          },
        ],
        manageUrl: [
          {
            required: true,
            message: "管理路径不能为空且以http://www或者https://www开头",
            trigger: "blur",
          },
        ],
        manageUrlJson: [
          {
            required: true,
            message: "子权限不能为空且以http://www或者https://www开头",
            trigger: "blur",
          },
        ],
        //
      },
    };
  },
  mounted() {
    this.getOrglist();
    this.$forceUpdate();
    this.getClickt();
  },
  // clients
  methods: {
    //检查客户端ID是否正确
    getClickt() {
      let self = this;
      let params = new FormData();
      self.$http.post(
        self.api.clients,
        params,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        },
        (res) => {
          self.clientList = res.body;
        },
        (error) => { }
      );
    },
    checkID() {
      let self = this;
      self.clickIdIsTrue = true;
      let checkRule = /^[0-9a-zA-Z]{2,20}$/;
      let result = checkRule.test(self.form.clientId);
      if (!result) {
        self.$message({
          message: "客户端ID只能是数字和字母组合且长度为2到20",
          type: "warning",
        });
        self.clickIdIsTrue = false;
        return false;
      }
      let params = new FormData();
      if (!self.form.clientId) {
        self.clickIdIsTrue = false;
        return false;
      }
      if (self.infoTitle == "编辑") {
        params.append("isAdd", "false");
      }
      if (self.infoTitle == "新增") {
        params.append("isAdd", "true");
      }
      params.append("menuId", self.addData.menuId);
      params.append("cilentId", self.form.clientId);

      self.$http.post(
        self.api.clientIdIsUnique,
        params,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        },
        (res) => {
          console.log(res.body, "body");
          if (res.body) {
            self.clickIdIsTrue = false;
            self.$message({
              message: "客户端ID重复,请重新输入",
              type: "warning",
            });
          }
        },
        (error) => { }
      );
    },
    changeUpdate() {
      this.$forceUpdate();
    },
    upFile() {
      var self = this;
      this.$refs.form.validate((valid) => {
        if (valid) {
          //文件
          var p1 = new Promise(function (resolve, reject) {
            let params = new FormData();
            for (let i = 0; i < self.fileList.length; i++) {
              params.append("file", self.fileList[i]);
            }
            if (self.fileList.length > 0) {
              self.$http.post(
                self.api.uploadFile,
                params,
                {
                  headers: {
                    "Content-Type": "multipart/form-data",
                  },
                },
                function (response) {
                  if (response.code == 200) {
                    self.upfiles = response.data;
                    self.form.icon = response.body;
                    resolve();
                  } else {
                    self.$message({
                      message: response.msg,
                      type: "error",
                    });
                  }
                },
                function (response) {
                  //失败回调
                }
              );
            } else {
              resolve();
            }
          });

          // Promise.all([p1]).then(function () {
          //   self.onSubmit();
          // });
        }
      });
    },
    onDrop(e) {
      e.preventDefault();
      let data = e.dataTransfer.files;

      for (let i = 0; i < data.length; i++) {
        let idx, ext, imgName, size;
        imgName = e.dataTransfer.files[i].name;
        idx = imgName.lastIndexOf(".");
        size = e.dataTransfer.files[i].size;
        if (imgName.length > 200) {
          this.$message({
            type: "warning",
            message: "文件名不超过200字符",
            duration: 1000,
          });
          return false;
        }
        if (idx != -1) {
          ext = imgName.substr(idx + 1).toUpperCase();
          ext = ext.toLowerCase();
          if (
            ext != "rar" &&
            ext != "zip" &&
            ext != "doc" &&
            ext != "docx" &&
            ext != "pdf" &&
            ext != "jpg" &&
            ext != "ppt" &&
            ext != "xls" &&
            ext != "xlsx" &&
            ext != "txt" &&
            ext != "png"
          ) {
            this.$message({
              type: "warning",
              message:
                "只支持上传rar .zip .doc .docx .pdf .jpg.ppt.xls.xlsx.txt.png文件",
              duration: 1000,
            });
          } else {
            if (size / 1024 > 2 * 10240) {
              this.$message({
                type: "warning",
                message: "文件过大",
                duration: 1000,
              });
            } else if (this.fileList.length >= 10) {
              this.$message({
                type: "warning",
                message: "最多可以上传10个附件",
                duration: 1000,
              });
            } else {
              var fr = new FileReader();
              let self = this;
              fr.onprogress = function (e) {
                self.upPercentage = (e.loaded / size) * 100;
              };
              fr.readAsDataURL(e.dataTransfer.files[i]);
              this.fileList.push(e.dataTransfer.files[i]);
              var pos = e.dataTransfer.files[i].name.lastIndexOf(".");
              var lastname = e.dataTransfer.files[i].name.substring(
                pos,
                e.dataTransfer.files[i].name.length
              );
              let name = e.dataTransfer.files[i].name;
              let sizss = (e.dataTransfer.files[i].size / 1024).toFixed(0);

              if (
                lastname != ".png" &&
                lastname != ".jpg" &&
                lastname != ".JPEG"
              ) {
                pos = e.dataTransfer.files[i].name.lastIndexOf(".");
                lastname = e.dataTransfer.files[i].name.substring(
                  pos,
                  e.dataTransfer.files[i].name.length
                );
                this.fileNameList.push({
                  fileName: e.dataTransfer.files[i].name,
                  filePath: "",
                  type: lastname,
                  size: (e.dataTransfer.files[i].size / 1024).toFixed(0),
                });
              } else {
                fr.onload = function (evt) {
                  self.fileNameList.push({
                    fileName: name,
                    filePath: "",
                    type: lastname,
                    size: sizss,
                    result: this.result,
                  });
                };
              }
            }
          }
        } else {
          this.$message({
            type: "warning",
            message:
              "只支持上传.zip .rar .txt .md .pdf .doc .docx .ppt .pptx .xls .xlsx .vsd .bmp .gif .jpeg .png .ioc .jpg .mp3 .oog .wma .mp4 .rmvb .mov .mkv .avi文件",
            duration: 1000,
          });
        }
      }
    },
    fileClick(id) {
      if (this.fileNameList.length > 1) {
        this.$message({
          message: "只能上传一个图标",
          type: "warning",
        });
        return false;
      }
      document.getElementById(id).click();
    },
    fileChange(el) {
      let mfilesList;
      let self = this;
      if (this.fileNameList.length > 0) {
        self.$message({
          message: "只能上传一个图标",
          type: "warning",
        });
        return false;
      }
      mfilesList = el.target.files;

      for (let i = 0; i < mfilesList.length; i++) {
        let idx, ext, imgName, size;
        imgName = el.target.files[i].name;
        idx = imgName.lastIndexOf(".");
        size = el.target.files[i].size;
        if (imgName.length > 200) {
          this.$message({
            type: "warning",
            message: "文件名不超过200字符",
            duration: 1000,
          });
          return false;
        }
        if (idx != -1) {
          ext = imgName.substr(idx + 1).toUpperCase();
          ext = ext.toLowerCase();
          if (
            ext != "rar" &&
            ext != "zip" &&
            ext != "doc" &&
            ext != "docx" &&
            ext != "pdf" &&
            ext != "jpg" &&
            ext != "ppt" &&
            ext != "xls" &&
            ext != "xlsx" &&
            ext != "txt" &&
            ext != "png"
          ) {
            this.$message({
              type: "warning",
              message:
                "只支持上传rar .zip .doc .docx .pdf .jpg.ppt.xls.xlsx.txt.png文件",
              duration: 1000,
            });
          } else {
            if (size / 1024 > 2 * 10240) {
              this.$message({
                type: "warning",
                message: "文件过大",
                duration: 1000,
              });
            } else if (this.fileList.length >= 10) {
              this.$message({
                type: "warning",
                message: "最多可以上传10个附件",
                duration: 1000,
              });
            } else {
              var fr = new FileReader();
              let self = this;
              fr.onprogress = function (e) {
                self.upPercentage = (e.loaded / size) * 100;
              };

              fr.readAsDataURL(mfilesList[i]);

              this.fileList.push(el.target.files[i]);
              var pos = el.target.files[i].name.lastIndexOf(".");
              var lastname = el.target.files[i].name.substring(
                pos,
                el.target.files[i].name.length
              );
              if (
                lastname != ".png" &&
                lastname != ".jpg" &&
                lastname != ".JPEG"
              ) {
                pos = el.target.files[i].name.lastIndexOf(".");
                lastname = el.target.files[i].name.substring(
                  pos,
                  el.target.files[i].name.length
                );
                this.fileNameList.push({
                  fileName: el.target.files[i].name,
                  filePath: "",
                  type: lastname,
                  size: (el.target.files[i].size / 1024).toFixed(0),
                });
              } else {
                fr.onload = function (evt) {
                  pos = el.target.files[i].name.lastIndexOf(".");
                  lastname = el.target.files[i].name.substring(
                    pos,
                    el.target.files[i].name.length
                  );
                  self.fileNameList.push({
                    fileName: el.target.files[i].name,
                    filePath: "",
                    type: lastname,
                    size: (el.target.files[i].size / 1024).toFixed(0),
                    result: this.result,
                  });
                };
              }
            }
          }
        } else {
          this.$message({
            type: "warning",
            message:
              "只支持上传.zip .rar .txt .md .pdf .doc .docx .ppt .pptx .xls .xlsx .vsd .bmp .gif .jpeg .png .ioc .jpg .mp3 .oog .wma .mp4 .rmvb .mov .mkv .avi文件",
            duration: 1000,
          });
        }
      }
    },
    fileDel(index) {
      let self = this;
      if (self.form.icon) {
        self.form.icon = "";
      }
      this.fileList.splice(index, 1);
      this.fileNameList.splice(index, 1);
      this.uploadtrue = false;
      setTimeout(function () {
        self.uploadtrue = true;
      }, 1);
    },
    getOrglist() {
      let self = this;
      self.$http.post(
        self.api.menuAll,
        {},
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        },
        (res) => {
          if (res) {
            self.data = res.body;
          } else {
          }
        },
        (error) => { }
      );
    },
    checkurl(title, url) {
      let self = this;
      var strRegex =
        /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&amp;:/~\+#]*[\w\-\@?^=%&amp;/~\+#])?/;
      var re = new RegExp(strRegex);
      if (!re.test(url)) {
        self.$message({
          message: `${title}填写错误`,
          type: "warning",
        });
        return false;
      }
      if (url.indexOf("http://") == 0 || url.indexOf("https://") == 0) {
        return "true";
      } else {
        self.$message({
          message: `${title}请以http://或者https://开头`,
          type: "warning",
        });
        return "false";
      }
      return true;
    },
    cancelSubmit() {
      this.showadd = false;
      // this.$refs.form.resetFields();
    },
    addSubmit(form) {
      let self = this;
      let result = "true";
      if (self.form.position == 0) {
        self.checkID();
      }
      if (self.form.position == 3) {
        let params = {};
        params.menuName = self.form.menuName;
        params.perms = self.form.perms;
        params.position = self.form.position;
        params.addType = self.form.addType;
        if (self.form.addType == "1") {
          params.parentMenuId = self.addData.menuId;
        } else {
          params.parentMenuId = self.addData.parentMenuId;
        }
        params.manageUrlJson = "";
        params.manageUrl = "";
        params.clientId = "";
        params.clientSecret = "";
        params.indexUrl = "";
        params.name = "";
        params.describe = "";
        params.icon = "";
        self.$http.post(
          self.api.addSamelevel,
          params,
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
          (res) => {
            if (res) {
              if (res.code == 200) {
                self.$message({
                  message: "新增成功",
                  type: "success",
                });
                self.showadd = false;
                self.$refs.form.resetFields();
                self.getOrglist();
              } else {
                self.$message({
                  message: res.msg,
                  type: "warning",
                });
              }
            } else {
            }
          },
          (error) => { }
        );
      } else {
        self.$refs[form].validate((valid) => {
          if (valid && self.clickIdIsTrue) {
            if (
              self.form.manageUrl &&
              (self.form.position == "0" || self.form.position == "2")
            ) {
              result = self.checkurl("管理路径", self.form.manageUrl);
            }
            if (
              !self.form.manageUrl &&
              (self.form.position == "0" || self.form.position == "2")
            ) {
              self.$message({
                message: `管理路径不能为空`,
                type: "warning",
              });
              return false;
            }
            if (
              self.form.manageUrlJson &&
              result == "true" &&
              self.form.position == "2"
            ) {
              result = self.checkurl("子权限API", self.form.manageUrlJson);
            }
            if (!self.form.manageUrlJson && self.form.position == "2") {
              self.$message({
                message: `子权限API不能为空`,
                type: "warning",
              });
              return false;
            }
            if (result == "true") {
              if (self.form.position == "0") {
                self.upFile();
              }
              setTimeout(() => {
                let params = {};
                params.menuName = self.form.menuName;
                params.perms = self.form.perms;
                params.position = self.form.position;
                params.addType = self.form.addType;
                if (self.form.addType == "1") {
                  params.parentMenuId = self.addData.menuId;
                } else {
                  params.parentMenuId = self.addData.parentMenuId;
                }
                if (self.form.position == "0") {
                  params.isClient = "true";
                } else {
                  params.isClient = "false";
                }
                if (self.form.position == "0" || self.form.position == "2") {
                  if (self.form.manageUrl.length > 255) {
                    self.$message({
                      message: "管理路径过长,超过255,请重新输入",
                      type: "warning",
                    });
                    return false;
                  }
                }
                params.manageUrl = self.form.manageUrl;
                if (self.form.position == 2) {
                  params.manageUrlJson = self.form.manageUrlJson;
                  params.clientId = self.form.clientId2;
                  params.clientSecret = "";
                  params.indexUrl = "";
                  params.name = "";
                  params.describe = "";
                  params.icon = "";
                } else {
                  params.manageUrlJson = "";
                  params.clientId = self.form.clientId;
                  params.clientSecret = self.form.clientSecret;
                  params.indexUrl = self.form.indexUrl;
                  params.name = self.form.name;
                  params.describe = self.form.describe;
                  params.icon = self.form.icon;
                }

                self.$http.post(
                  self.api.addSamelevel,
                  params,
                  {
                    headers: {
                      "Content-Type": "application/json",
                    },
                  },
                  (res) => {
                    if (res) {
                      if (res.code == 200) {
                        self.$message({
                          message: "新增成功",
                          type: "success",
                        });
                        self.showadd = false;
                        self.$refs.form.resetFields();
                        self.getOrglist();
                      } else {
                        self.$message({
                          message: res.msg,
                          type: "warning",
                        });
                      }
                    } else {
                    }
                  },
                  (error) => { }
                );
              }, 2000);
            }
          }
        });
      }
      // }
    },
    add(data) {
      this.$forceUpdate();
      this.form = {
        indexUrl: "",
        name: "",
        describe: "",
        menuName: "",
        perms: "",
        addType: "0",
        position: "0",
        manageUrlJson: "",
        manageUrl: "",
        isClient: "false",
        clientId: "",
        clientSecret: "",
        icon: "",
      };
      this.fileNameList = [];
      this.showadd = true;
      this.addData = data;
      this.infoTitle = "新增";
    },
    edit(data) {
      let self = this;
      self.$forceUpdate();
      self.showadd = true;
      self.fileNameList = [];
      self.infoTitle = "编辑";
      self.addData = data;
      // self.form = data;
      for (let key in self.form) {
        self.form[key] = "";
      }

      self.form.position = String(data.position);
      self.form.menuName = data.menuName;
      self.form.perms = data.perms;
      if (data.icon) {
        let obj = {
          fileName: data.icon,
        };
        self.fileNameList.push(obj);
      }
      // if (self.form.clientDetails) {
      //   self.form.name = self.form.clientDetails.name;
      //   self.form.describe = self.form.clientDetails.describe;
      //   self.form.clientSecret = self.form.clientDetails.clientSecret;
      //   self.form.indexUrl = self.form.clientDetails.indexUrl;
      // }
      self.form.manageUrl = data.manageUrl;

      if (self.form.position == 0) {
        self.form.clientId = data.clientDetails.clientId;
        self.form.clientSecret = data.clientDetails.clientSecret;
        self.form.indexUrl = data.clientDetails.indexUrl;
        self.form.name = data.clientDetails.name;
        self.form.describe = data.clientDetails.describe;
        self.form.icon = data.clientDetails.icon;
      } else if (self.form.position == 2) {
        self.form.clientId2 = data.clientId;
        self.form.manageUrlJson = data.manageUrlJson;
      }
      self.form.isClient = String(self.form.isClient);
      self.$forceUpdate();
    },
    editSubmit(form) {
      let self = this;
      let result = "true";
      self.loading = true;
      if (self.form.position == 0) {
        self.checkID();
      } else {
        self.clickIdIsTrue = true;
      }
      if (
        self.form.manageUrl &&
        (self.form.position == "0" || self.form.position == "2")
      ) {
        result = self.checkurl("管理路径", self.form.manageUrl);
      }
      if (
        !self.form.manageUrl &&
        (self.form.position == "0" || self.form.position == "2")
      ) {
        self.$message({
          message: `管理路径不能为空`,
          type: "warning",
        });
        return false;
      }
      if (
        self.form.manageUrlJson &&
        result == "true" &&
        self.form.position == "2"
      ) {
        result = self.checkurl("子权限API", self.form.manageUrlJson);
      }
      if (!self.form.manageUrlJson && self.form.position == "2") {
        self.$message({
          message: `子权限API不能为空`,
          type: "warning",
        });
        return false;
      }
      if (self.form.position == "0" || self.form.position == "2") {
        if (self.form.manageUrl.length > 255) {
          self.$message({
            message: "管理路径过长,超过255,请重新输入",
            type: "warning",
          });
          return false;
        }
      }
      setTimeout(function () {
        if (result == "true" && self.clickIdIsTrue) {
          self.$refs[form].validate((valid) => {
            if (valid) {
              if (self.form.position == "0") {
                self.upFile();
              }
              self.showadd = false;
              setTimeout(function () {
                let params = {};
                params.menuId = self.addData.menuId;
                params.menuName = self.form.menuName;
                params.perms = self.form.perms;
                params.position = self.form.position;
                params.addType = self.form.addType;
                if (self.form.position == "0") {
                  params.clientId = self.form.clientId;
                } else if (self.form.position == "2") {
                  params.clientId = self.form.clientId2;
                }
                if (self.form.position == "0") {
                  params.isClient = "true";
                } else {
                  params.isClient = "false";
                }
                if (!self.form.clientId2 && self.form.position == "2") {
                  self.$message({
                    message: "应用模块不能为空",
                    type: "warning",
                  });
                  return flase;
                }
                params.manageUrl = self.form.manageUrl;
                if (self.form.position == 2) {
                  params.manageUrlJson = self.form.manageUrlJson;
                  params.clientId = self.form.clientId2;
                  params.clientSecret = "";
                  params.indexUrl = "";
                  params.name = "";
                  params.describe = "";
                  params.icon = "";
                } else if (self.form.position == 0) {
                  params.manageUrlJson = "";
                  params.clientId = self.form.clientId;
                  params.clientSecret = self.form.clientSecret;
                  params.indexUrl = self.form.indexUrl;
                  params.name = self.form.name;
                  params.describe = self.form.describe;
                  params.icon = self.form.icon;
                }

                self.$http.post(
                  self.api.updateMenu,
                  params,
                  {
                    headers: {
                      "Content-Type": "application/json",
                    },
                  },
                  (res) => {
                    if (res.code != 200) {
                      self.$message({
                        message: res.msg,
                        type: "warning",
                      });
                      self.loading = false;
                      self.getOrglist();
                    } else {
                      self.getOrglist();
                      self.loading = false;
                    }
                  },
                  (error) => { }
                );
              }, 2000);
            }
          });
        }
      }, 1000);
    },
    remove(node, data) {
      let self = this;
      self
        .$confirm("此操作将永久删除该菜单, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          let params = {};
          params.organizeId = data.organizeId;
          params.parentOrganizateId = data.parentId || "";
          self.$http.post(
            self.api.adeleteMenull + `?menuId=${data.menuId}`,
            {},
            {
              headers: {
                "Content-Type": "application/json",
              },
            },
            (res) => {
              if (res) {
                self.getOrglist();
                self.$message.success("成功删除！");
              } else {
              }
            },
            (error) => { }
          );
        })
        .catch(() => { });
    },
  },
  components: { headerTop, navLeft },
};
</script>
<style>
#rolePower .el-upload-dragger .el-icon-upload {
  margin: 0;
}

#rolePower .savebtn {
  display: block;
  margin: 0 auto;
  margin-top: 400px;
  width: 50%;
  text-align: center;
}

#rolePower .savebtn button {
  width: 100%;
}

#rolePower .el-tree-node__content {
  display: block;
  margin: 0 auto;
  margin-bottom: 15px;
}

#rolePower .system {
  /* padding: 20px 50px 84px; */
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: fixed;
  left: 320px;
  bottom: 0;
  top: 84px;
  right: 20px;
  height: 100%;
  overflow-y: auto;
}

#rolePower .system>div {
  width: 30%;
  /* margin: 0 auto; */
}

#rolePower .addPosition {
  position: absolute;
  right: 0;
  margin-top: -10px;
}

#rolePower .el-select {
  width: 180px;
  margin-right: 15px;
}

#rolePower .addPosition i {
  font-size: 16px;
}

.custom-tree-node {
  font-size: 18px;
}

#rolePower .addPosition i {
  font-size: 18px;
}

#rolePower .dialog-class .el-dialog__header {
  padding: 15px 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

#rolePower .dialog-class .el-dialog__footer {
  padding: 15px 20px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}

#rolePower .dialog-class .el-dialog__header .el-dialog__title {
  font-weight: 600;
  color: #606266;
}

#rolePower .el-button--mini {
  padding: 0;
}
</style>


// WEBPACK FOOTER //
// src/view/rolePower.vue